"use client";

import { useId, useState } from "react";

import type { ReactElement } from "react";

export interface DisclosureChildrenProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  toggle: () => void;
  buttonProps: Record<string, unknown>;
  panelProps: Record<string, unknown>;
}

export interface ToggleCallbackProps {
  isOpen: boolean;
}

export interface DisclosureProps {
  children: (props: DisclosureChildrenProps) => ReactElement;
}

export const Disclosure = function Disclosure(
  props: DisclosureProps,
): ReactElement {
  const [open, setOpen] = useState<boolean>(false);

  const id = useId();
  const buttonID = `up-disclosure-btn-${id}`;
  const panelID = `up-disclosure-${id}`;

  const buttonProps = {
    id: buttonID,
    "aria-expanded": open ? "true" : "false",
    "aria-controls": panelID,
  };

  const panelProps = {
    id: panelID,
    role: "region" as const,
    "aria-labelledby": buttonID,
    inert: open ? undefined : true,
  };

  const toggle = function () {
    setOpen(!open);
  };

  return props.children({
    open,
    setOpen,
    toggle,
    buttonProps,
    panelProps,
  });
};
